import { Pipe, PipeTransform } from '@angular/core';
import { RotinaCliente } from '../../modelos/rotina-cliente';
import { ConfigOcorrenciaAuto } from '../../modelos/config-ocorrencia-auto';

@Pipe({
  name: 'filtroRotinaCliente'
})
export class FiltroRotinaClientePipe implements PipeTransform {

  transform(configs: ConfigOcorrenciaAuto[], filtro?: string): any {
    if (configs === undefined || filtro === undefined || filtro.trim() === '') {
      return configs;
    }
    filtro = filtro.toLocaleLowerCase();
    return configs.filter(config => config.rotinaCliente.descricaoRotina.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-rotina-cliente.pipe.ts